import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "utils/getToken";
import {
  fieldLabel,
  input as inputCls,
  pageKicker,
  pageTitle,
  primaryBtn,
  select as selectCls,
} from "components/ui/instrument";

const PaymentLink = (props: unknown) => {
  const navigate = useNavigate();
  const [linkFound, setLinkFound] = useState(false);
  const [link, setLink] = useState("");
  const [mobile, setMobile] = useState("");
  const [payReason, setPayReason] = useState("");
  const [couponId, setCouponId] = useState<number | string>(0);
  const [couponData, setCouponData] = useState<any>(0);
  const [amount, setAmount] = useState<number | string>(0);
  const [copyMsg, setCopyMsg] = useState("Copy");
  const [clicked, setClicked] = useState(false);

  const createLink = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (payReason === "" || payReason === "Select Reason for Payment") {
      alert("Reason of Payment is Mandatory");
    } else {
      setClicked(true);
      axios
        .post(
          process.env.REACT_APP_API_URL + "payments/payment-link/",
          {
            mobile: mobile,
            amount: parseInt(amount as string) * 100,
            payment_reason: payReason,
            payment_source: "Support Portal",
            coupon_id: couponId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Token " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          setClicked(false);
          setLink(res.data.url);
          setLinkFound(true);
        })
        .catch((err: any) => {
          setClicked(false);
          if (err.response.status === 401) {
            localStorage.clear();
            navigate("/");
          }
          toast.error("Unable to create link! ");
        });
    }
  };

  const couponDataFetcher = async () => {
    try {
      const url = process.env.REACT_APP_API_URL + "subscription/coupons/";

      const response = await axios.get(url, {
        headers: {
          Authorization: `Token ${getToken()}`,
          "Content-Type": "application/json",
        },
      });
      //  console.log(response);
      if (response.data && response.data.length > 0) {
        setCouponData([...response.data]);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };

  const copyText = () => {
    navigator.clipboard.writeText(link);
    setCopyMsg("Copied");
    setTimeout(() => {
      setCopyMsg("Copy");
    }, 1000);
  };

  const linkComponent = () => {
    if (linkFound) {
      return (
        <div className="flex justify-center">
          <div className="w-screen rounded-lg border border-clinic-200 bg-white p-8 text-center shadow-sm">
            <p className="link mb-6 break-all rounded-md border border-clinic-200 bg-clinic-50 px-4 py-4 font-mono text-sm text-clinic-800">
              {link}
            </p>
            <button onClick={copyText} className={`${primaryBtn} px-4`}>
              {copyMsg}
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="flex flex-col items-center overflow-hidden px-4 md:px-12">
        <div className="mt-4 flex w-full flex-col items-center sm:mt-6">
          {/* Form start */}
          <form className="flex w-[100%] flex-col space-y-4">
            <div className="w-full">
              <div className="my-6 md:my-8">
                <p className={pageKicker}>Babynama Clinic-OS</p>
                <h2 className={pageTitle}>
                  Payment Link
                </h2>
              </div>
              {linkComponent()}
              {linkFound ? null : (
                <div>
                  <div className="mt-4">
                    <label className={fieldLabel}>
                      Mobile No. <b className="text-crit-500">*</b>
                    </label>
                    <input
                      className={`${inputCls} tabular-nums`}
                      type="text"
                      placeholder="Mobile"
                      value={mobile}
                      onChange={(e) => {
                        setMobile(e.target.value);
                      }}
                    />
                  </div>

                  <div className="mt-4">
                    <label className={fieldLabel}>
                      Payment Reason <b className="text-crit-500">*</b>
                    </label>
                    <select
                      className={`${selectCls} w-full`}
                      onChange={(e) => setPayReason(e.target.value)}
                    >
                      <option>Select Reason for Payment</option>
                      <option>Consultation - Pediatrics</option>
                      <option>Consultation - Gynecologist</option>
                      <option>Consultation - Dermatalogy</option>
                      <option>Consultation - Lactation</option>
                      <option>Consultation - Nutritionist</option>
                      <option>Consultation - PPD</option>
                      <option>Subscription - OneWeek_Trial (7 Days)</option>
                      <option>Subscription - Essential (1)</option>
                      <option>Subscription - Essential (3)</option>
                      <option>Subscription - BTP (1)</option>
                      <option>Subscription - Holistic_New (1)</option>
                      <option>Subscription - Holistic_New (3)</option>
                      <option>Subscription - Holistic_Old (1)</option>
                      <option>Subscription - Holistic_Old (3)</option>
                      <option>Subscription - Vaccination</option>
                      <option>Pregnancy</option>
                      <option>Preloved Item</option>
                      <option>Subscription - Nurture (1 Month)</option>
                      <option>Subscription - Nurture (3 Months)</option>
                      <option>Subscription - Nurture (6 Months)</option>
                      <option>Subscription - Nurture (12 Months)</option>
                      <option>Subscription - WTP (1)</option>
                      <option>Subscription - WTP (3)</option>
                      <option>Subscription - STP (1)</option>
                      <option>
                        Subscription - Toilet Training Program TTP (1)
                      </option>
                      <option>Subscription - Basic (1)</option>
                      <option>Subscription - Basic (3)</option>
                      <option>Subscription - Prime (1)</option>
                      <option>Subscription - Prime (3)</option>
                      <option>Subscription - Basic 499</option>
                      <option>Others</option>
                    </select>
                  </div>

                  <h1 className="mt-4 w-full rounded-md border border-clinic-200 bg-clinic-50 py-2 px-4 text-sm text-clinic-500">
                    INR
                  </h1>
                  <div className="mt-4">
                    <label className={fieldLabel}>
                      Amount <b className="text-crit-500">*</b>
                    </label>
                    <input
                      className={`${inputCls} tabular-nums`}
                      type="number"
                      placeholder="Amount"
                      step={0.01}
                      value={amount}
                      onChange={(e) => {
                        setAmount(e.target.value);
                      }}
                    />
                  </div>
                  <div className="mt-4 mb-4">
                    <label className={fieldLabel}>Coupon</label>
                    <select
                      className={`${selectCls} w-full`}
                      onChange={(e) => setCouponId(e.target.value)}
                    >
                      <option value={0}>Select a Coupon</option>
                      <option value={1}>EXTRA</option>
                    </select>
                  </div>

                  {clicked ? (
                    <button
                      className={`${primaryBtn} w-full cursor-wait opacity-50 md:col-span-2`}
                    >
                      Loading...
                    </button>
                  ) : (
                    <button
                      className={`${primaryBtn} w-full md:col-span-2`}
                      onClick={(e) => createLink(e)}
                    >
                      Create
                    </button>
                  )}
                </div>
              )}
            </div>
          </form>
        </div>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default PaymentLink;
